import { ENV } from '@sitegen/common/constants/environments';

export const ANALYTICS_SCRIPT_URL = {
    [ENV.DEV]: 'https://ubistatic-a.akamaihd.net/0106/uat/global/tracking/analyticssdk.js',
    [ENV.PROD]: 'https://ubistatic-a.akamaihd.net/0106/prod/global/tracking/analyticssdk.js'
};

export const SITE_CATEGORY = 'Responsive Site';
export const ANALYTICS_GLOBAL_NS = 'wa_data';
export const ANALYTICS_SDK = 'adobeAnalytics';
export const ANALYTICS_READY_EVENT = 'S_CODE_READY';

export enum ANALYTICS_EVENTS {
    PAGE_EVENT = 'pageevent',
    CLICK_EVENT = 'clickevent',
    ERROR_EVENT = 'clickevent',
    ACCOUNT_EVENT = 'accountevent',
}
